import { render, staticRenderFns } from "./WaitingFor.vue?vue&type=template&id=63ee71a0&"
import script from "./WaitingFor.vue?vue&type=script&lang=ts&"
export * from "./WaitingFor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports